import { FolderKanbanIcon, HistoryIcon, FoldersIcon, SettingsIcon, UsersIcon, type LucideIcon } from 'lucide-react'

import type { CurrentUser } from '@/modules/accounts'

export const paths = {
  login: '/login',
  /** Where everyone lands after signing in. */
  projects: '/projects',
  createProject: '/projects/new',
  projectDetail: (id: string) => `/projects/${encodeURIComponent(id)}`,
  editProject: (id: string) => `/projects/${encodeURIComponent(id)}/edit`,
  users: '/users',
  collections: '/collections',
  collection: (id: string) => `/collections/${encodeURIComponent(id)}`,
  /** Only the variations of one project live under here; there is no templates list any more (see Collections). */
  templates: '/templates',
  template: (projectId: string) => `/templates/${encodeURIComponent(projectId)}`,
  notifications: '/notifications',
  settings: '/settings',
} as const

/** Data attached to a route via `handle`. `title` is shown in the app bar. */
export interface RouteHandle {
  title: string
}

export interface NavItem {
  label: string
  to: string
  icon: LucideIcon
  /** Show the unread-notification count on this item. */
  unreadBadge?: boolean
  /** Shown in the desktop sidebar, greyed out and not clickable, until the page exists. */
  comingSoon?: boolean
}

/**
 * One shared shell for every persona: Projects, Users, Collections (folders of templates), then Activity and Settings (not built yet: "coming soon") (notifications live in the bell in the app bar). Users appears only for people who may
 * manage users (SupplyLogic admins: everyone; supplier and client admins: their own account). There is deliberately no
 * Suppliers or Clients entry. Hiding a link is only a convenience: the route and the commands check the same rule.
 */
export function navItemsFor(_user: CurrentUser): NavItem[] {
  return [
    { label: 'Projects', to: paths.projects, icon: FolderKanbanIcon },
    { label: 'Users', to: paths.users, icon: UsersIcon },
    { label: 'Collections', to: paths.collections, icon: FoldersIcon },
    { label: 'Activity', to: '/activity', icon: HistoryIcon, comingSoon: true },
    { label: 'Settings', to: paths.settings, icon: SettingsIcon, comingSoon: true },
  ]
}
